import ArrowPrev from './ArrowPrev'
import ArrowNext from './ArrowNext'

export {
  ArrowPrev,
  ArrowNext
}



// WEBPACK FOOTER //
// ./src/components/index.js